import QRow from './src/QRow';

QRow.install = Vue => {
  Vue.component(QRow.name, QRow);
};

export default QRow;
